import React from 'react';
import { BlogArticleTemplate } from '../../components/blog/BlogArticleTemplate';
import { chooseDentistArticle } from '../../data/blog/chooseDentistArticle';
export function ChooseDentistArticle() {
  return <BlogArticleTemplate article={chooseDentistArticle} data-id="element-803" data-mp="172tdfe6zq59w" />;
}